/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { Button as BaseButton } from '../../../components';
import withModal from '../../../lib/withModal';
import { FormattedMessage } from 'react-intl';

import AddCabinetDialog from '../containers/AddCabinetDialog';

const Button = styled(BaseButton)`
    width: 160px;
`;

const AddCabinetButton = ({ open, onClose, onOpen }) => (
    <AddCabinetDialog
        open={open}
        onClose={onClose}
        trigger={
            <Button onClick={onOpen} labelPosition="left" primary icon>
                <Icon name="add" />
                <FormattedMessage
                    id="pages.cabinets.CabinetList.newCabinet"
                    defaultMessage="Create new cabinet"
                />
            </Button>
        }
    />
);

export default withModal(AddCabinetButton);
